var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.data.fields.cardBody.content),function(step,j){return _c('div',{key:j},_vm._l((step.content),function(step2,i){return _c('div',{key:i},[_c('div',{domProps:{"innerHTML":_vm._s(step2.value)}})])}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }